'use client';
/**
 * 推薦閱讀Popin
 * Doc: https://dashboard.popin.cc/discovery/accounts/tags-tw/me/cnyes_tw
 */
import { CustomEventName, GTMConstants, GTMEventKey, sendGTM } from '@fe-cnyes/fe-common-gtm';
import { styled } from '@linaria/react';
import Script from 'next/script';

const DELAY_SECONDS = 3000;

const View = styled.div<{ isDesktop: boolean }>`
  margin-top: 40px;
  margin-bottom: ${({ isDesktop }) => (isDesktop ? '40px' : '0px')};
`;

/**
 * 這邊採取的策略是，等待外部推薦閱讀區塊的 Javascript SDK 載入後，利用 onReady callback
 * 因為 onReady 不等同於 SDK 正常完成渲染新聞內頁 DOM 元素
 * 所以先暫定等待 3 秒後，再進行 DOM 元素的解析
 *
 * 這邊的解析方式是，透過 querySelector 找到所有的推薦閱讀文章，並且依據每個文章的資訊來決定 GA 事件類型 (有 pr 就是廣告，沒有就是新聞)
 * 然後再把 GA 事件 normalize 放在 data attribute 裡面，等待點擊時觸發
 */
function onPopInScriptReady() {
  const root = document.querySelector('._popIn_recommend');

  setTimeout(() => {
    const articles = root?.querySelectorAll('._popIn_recommend_article') || [];

    if (articles && articles.length > 0) {
      for (const article of articles) {
        const pr = article.querySelector('._popIn_recommend_art_media') || undefined;
        const title = article.querySelector('._popIn_recommend_art_title a')?.textContent || '';
        const links = article.querySelectorAll('a');

        for (const link of links) {
          const gaEvent = {
            [GTMEventKey.EVENT_NAME]: pr ? CustomEventName.CLICK_AD : CustomEventName.CLICK_NEWS,
            [GTMEventKey.SECTION]: `${GTMConstants.SECTION_PLACEHOLDER}_推薦閱讀`,
            [GTMEventKey.CLICK_ITEM]: title
          };

          link.dataset.gtmEvent = JSON.stringify(gaEvent);

          link?.addEventListener('click', event => {
            const target = event.currentTarget as HTMLAnchorElement;
            const gaEvent = JSON.parse(target.dataset.gtmEvent || '{}');
            sendGTM(gaEvent);
          });
        }
      }
    }
  }, DELAY_SECONDS);
}

type PopinProps = {
  isDesktop: boolean;
};

const Popin: React.FC<PopinProps> = ({ isDesktop }) => {
  return (
    <View isDesktop={isDesktop}>
      <Script type='text/javascript' src='https://api.popin.cc/searchbox/cnyes_tw.js' onReady={onPopInScriptReady} />
      <div className='_popIn_recommend' />
    </View>
  );
};

export default Popin;
